import React, { useEffect } from "react";
import EmployeeSelectView from "./employee-select.view";
import { getEmployeeDetailById, getEmployeeList } from "./action/employee-select.action";
import { useBaseComponent } from "../../../base/base-component";
import { IEmployeeSelect, IState } from "./type/employee-select.types";
import { message } from "antd";
import '../../../styles/component/employee-select.scss';


const EmployeeSelect:React.FC<IEmployeeSelect> = (props) => {

    const {state, updateState} = useBaseComponent<{}, IState>({}, {
        initialState: () => ({
            data: {
                employeeList: []
            },
            internal: {
                selectedEmployeeId: props.value??'',
                maxItems: 30,
                searchQuery: '',
                pagination: {
                    hasNext: false,
                    hasPrevious: false,
                    isLoading: false,
                    pageSize: 10,
                    pageNumber: 0,
                }
            }
        }),
        onInit: () => onInit()
    });

    useEffect(()=>{
        updateState('internal.selectedEmployeeId', props.value??'');
    },[props.value])

    async function onInit() {
        let response;
        const res = await getEmployeeList('');
        response=res;
        if(props.value){
            const employeeDetail= await getEmployeeDetailById(props.value);
            response=[...res,employeeDetail];
        }
        const uniqueEmployees = Array.from(
            new Map(response.map((emp:any) => [emp.id, emp])).values()
        );

        updateState('data.employeeList', uniqueEmployees);
        updateState('internal.pagination', {
            ...state.internal.pagination,
            hasNext: res.length === state.internal.pagination.pageSize,
        })
    }


    function handleChange(id: string) {
        updateState('internal.selectedEmployeeId', id);
        props.onChange?.(id);
    }

    async function loadMoreData() {
        updateState('internal.pagination.isLoading', true);
        const nextPageNumber = state.internal.pagination.pageNumber + 1;
        try {
            const res = await getEmployeeList(state.internal.searchQuery,
                state.internal.pagination.pageSize, nextPageNumber);

            let merged = [...state.data.employeeList,...res];
            let uniqueEmployees = Array.from(
                new Map(merged.map((emp:any) => [emp.id, emp])).values()
            );
            // if docs length is more than maxItems then keep latest items
            if (uniqueEmployees.length > state.internal.maxItems) {
                uniqueEmployees = uniqueEmployees.slice(uniqueEmployees.length - state.internal.maxItems);
            }

            updateState('internal.pagination', {
                ...state.internal.pagination,
                hasNext: res.length === state.internal.pagination.pageSize,
                pageNumber: nextPageNumber
            });

            updateState('data.employeeList',uniqueEmployees);

        } catch (e) {
            message.error('something went wrong')
            console.log('error occurred while loading more data', e)
        } finally {
            updateState('internal.pagination.isLoading', false);
        }

    }

    async function loadPreviousData() {
        updateState('internal.pagination.isLoading', true);
        const previousPageNumber = state.internal.pagination.pageNumber - 1;
        if (previousPageNumber < 0) {
            updateState('internal.pagination.hasPrevious', false)
            return;
        }
        try {
            const res = await getEmployeeList(state.internal.searchQuery,
                state.internal.pagination.pageSize, previousPageNumber);

            let merged = [...res, ...state.data.employeeList];
            let uniqueEmployees = Array.from(
                new Map(merged.map((emp:any) => [emp.id, emp])).values()
            );
            // if docs length is more than maxItems then keep latest items
            if (uniqueEmployees.length > state.internal.maxItems) {
                uniqueEmployees = uniqueEmployees.slice(0, state.internal.maxItems);
            }
            updateState('internal.pagination', {
                ...state.internal.pagination,
                hasPrevious: true,
                hasNext: res.length === state.internal.pagination.pageSize,
                pageNumber: previousPageNumber
            });

            updateState('data.employeeList', uniqueEmployees);

        } catch (e) {
            message.error('something went wrong')
            console.log('error occurred while loading more data', e)
        } finally {
            updateState('internal.pagination.isLoading', false);
        }
    }

    async function handleSearch(searchQuery: string) {
        const searchText = searchQuery.trim();
        updateState('internal.searchQuery', searchText);
        const res = await getEmployeeList(searchText, state.internal.pagination.pageSize, 0);
        updateState('data.employeeList', res);

    }

    function handleDropdownClose(isOpen:boolean) {
           if(!isOpen){
               updateState('internal.searchQuery','');
           }
    }

    return (
        <EmployeeSelectView
            disabled={props.disabled}
            includeAllEmployeeOption={props.includeAllSelectOption}
            placeholderText={props.placeholder}
            selectedId={state.internal.selectedEmployeeId}
            data={state.data.employeeList}
            handleChange={handleChange}
            handleSearch={handleSearch}
            handleDropdownClose={handleDropdownClose}
            paginationControls={{
                isLoading: state.internal.pagination.isLoading,
                loadNext: loadMoreData,
                loadPrevious: loadPreviousData,
                hasNext: state.internal.pagination.hasNext,
                hasPrevious: state.internal.pagination.hasPrevious
            }}
        />
    )
}
export default EmployeeSelect;
